export default "/_next/static/videos/31d099decf0a83ab8da31c1c7357d8ff.mp4";